import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "types/store";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as viewReducer from "containers/View/reducer";
import { TemplateItem } from "components/View/TemplatesView";
import styles from "components/Templates/style.module.css";
import * as globalReducer from "@/containers/App/reducer";
import { useHistory } from "react-router-dom";
import * as homeReducer from "@/containers/Home/reducer";
import { delay } from "utils/promise";
const SearchTemplateRecommendations = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const artifactId = useSelector((state) => chatGPTReducer.getArtifactId(state));
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    const templateChatApps = useSelector((state) => viewReducer.getSearchFilteredChatTemplates(state));
    const activeMultiDataMessageIndex = useSelector((state) => chatGPTReducer.getActiveMultiDataMessageIndex(state));
    const conversationArray = useSelector((state) => chatGPTReducer.getConversationArray(state));
    const foundMessage = conversationArray.find((message) => message?.messageIndex === activeMultiDataMessageIndex);
    const retDatasets = (foundMessage?.askChatGPT_MultipleDatasets ?? []).filter((dataset) => dataset?.id === datasetId);
    const retDocuments = (foundMessage?.askChatGPT_MultipleDocuments ?? []).filter((document) => document?.id === artifactId);
    const bothData = [...(retDatasets ?? []), ...(retDocuments ?? [])].sort((a, b) => a?.rank - b?.rank < 0 ? -1 : a?.rank === b?.rank ? 0 : 1);
    const userChatApps = (templateChatApps ?? [])
        .filter((c) => (bothData ?? []).find((b) => b.id === c?.wizard?.datasetId || b.id === c?.wizard?.artifactId) !== undefined)
        .filter((item) => item?.wizard?.isSavedWork === true);
    // Add filtered prebuilt templates to this
    const sampleTemplates = useSelector((state) => viewReducer.getRecommendedSampleTemplates(state, bothData));
    const retChatApps = [...userChatApps, ...sampleTemplates];
    const DEFAULT_TEMPLATE_COUNT = 3;
    const [showAllRecommendedChatApps, setShowAllRecommendedChatApps] = useState(false);
    // Hide the long list when the user clicks a different dataset
    useEffect(() => {
        setShowAllRecommendedChatApps(false);
    }, [datasetId, artifactId]);
    const displayChatApps = showAllRecommendedChatApps ? retChatApps : retChatApps.slice(0, DEFAULT_TEMPLATE_COUNT);
    const [selectedApp, updateSelectedApp] = useState(undefined);
    const isAgentPlural = retChatApps?.length > 1;
    const retAgentsTitle = `Here ${isAgentPlural ? "are" : "is"} ${retChatApps?.length} agent${isAgentPlural ? "s" : ""} that match${isAgentPlural ? "" : "es"} this dataset`;
    const searchFilteredChatApps = useSelector((state) => viewReducer.getSearchFilteredChatTemplates(state));
    const searchFilteredBenchmarks = useSelector((state) => viewReducer.getSearchFilteredChatTemplates(state, "", "BENCHMARK"));
    const searchFilteredChatUseCases = useSelector((state) => viewReducer.getSearchFilteredUsecaseTemplates(state));
    const searchFilteredItems = [...searchFilteredChatApps, ...searchFilteredBenchmarks, ...searchFilteredChatUseCases];
    const notSavedFilteredItems = searchFilteredItems.filter((item) => item?.wizard?.isSavedWork !== true);
    let DEFAULT_STRUCTURED_TEMPLATES = ["CHATAIBLE_ANALYTICS", "CHATAIBLE_SQL"];
    const DEFAULT_UNSTRUCTURED_TEMPLATES = ["CHATAIBLE_DOCUMENT_SUMMARIZATION"];
    if (dataset?.outcome) {
        DEFAULT_STRUCTURED_TEMPLATES = [
            ...DEFAULT_STRUCTURED_TEMPLATES,
            "WHATS_CHANGED_TEMPLATE",
            "WHATS_CHANGED_OVERVIEW_TEMPLATE"
        ];
    }
    const defaultStructuredTemplates = notSavedFilteredItems.filter((item) => DEFAULT_STRUCTURED_TEMPLATES.includes(item.id));
    const defaultUnstructuredTemplates = notSavedFilteredItems.filter((item) => DEFAULT_UNSTRUCTURED_TEMPLATES.includes(item.id));
    const handleTemplateClick = (item) => {
        if (item?.optimizeSetup !== undefined || item?.agentType === "OPTIMIZE") {
            return dispatch(chatGPTReducer.initChatApp(item));
        }
        if (item.itemType === "Agent") {
            return history.push("/templates/" + item?.id);
        }
        dispatch(globalReducer.updateIsSkipNextInit(undefined));
        dispatch(globalReducer.updateIsSkipChatGPTInit(undefined));
        dispatch(globalReducer.updateIsSkipChatGPTReset(undefined));
        if (datasetId && datasetId !== "new") {
            return history.push("/chatTemplate/" + item?.id, { datasetId });
        }
        else if (artifactId) {
            return history.push("/chatTemplate/" + item?.id, { artifactId });
        }
        return history.push("/chatTemplate/" + item?.id);
    };
    const handleAgentClick = async (e, item) => {
        e.stopPropagation();
        await delay(5);
        dispatch(chatGPTReducer.updateShowTemplateRecommendations(false));
        const options = {
            skipAutoChats: true,
            skipRedirects: true,
            skipUpdateActiveTab: true
        };
        if (nextId && !isNaN(Number(nextId))) {
            options.nextIdOverride = Number(nextId);
        }
        if (datasetId && !isNaN(Number(datasetId))) {
            options.datasetId = Number(datasetId);
        }
        if (artifactId && !isNaN(Number(artifactId))) {
            options.artifactId = Number(artifactId);
        }
        return await dispatch(chatGPTReducer.initChatAppInCurrentChat(item, true, options));
    };
    return (React.createElement("div", { className: styles.searchTemplateRecommendationsWrapper },
        retChatApps?.length > 0 && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.searchTemplateRecommendationsTitle }, retAgentsTitle),
            displayChatApps.map((chatApp) => {
                return (React.createElement("div", { onClick: (e) => handleAgentClick(e, chatApp) },
                    React.createElement(TemplateItem, { item: chatApp, selectedItem: selectedApp, updateSelectedItem: updateSelectedApp, style: { maxWidth: "unset" }, key: "topSampleTemplate__" + chatApp?.id, showHoverOptions: false, hideDelete: true, hideShare: true, dontHighlight: true, useCurrentDatasetSelection: true })));
            }),
            React.createElement("a", { className: styles.searchTemplateREcommendationsLink, onClick: () => setShowAllRecommendedChatApps(!showAllRecommendedChatApps) }, showAllRecommendedChatApps ? "Show Less" : "Show All"))),
        React.createElement("div", { className: styles.searchTemplateRecommendationsTitle }, "Creating a new agent? Select the type of analysis you want to use:"),
        datasetId &&
            datasetId !== "new" &&
            defaultStructuredTemplates.map((template) => {
                return (React.createElement("div", { onClick: () => handleTemplateClick(template) },
                    React.createElement(TemplateItem, { item: template, openOnClick: false, selectedItem: selectedApp, updateSelectedItem: updateSelectedApp, style: { maxWidth: "unset" }, key: "topSampleTemplate__" + template?.id, reInitFromChat: true, showHoverOptions: false, hideDelete: true, hideShare: true, dontHighlight: true })));
            }),
        artifactId &&
            defaultUnstructuredTemplates.map((template) => {
                return (React.createElement("div", { onClick: () => handleTemplateClick(template) },
                    React.createElement(TemplateItem, { item: template, openOnClick: false, selectedItem: selectedApp, updateSelectedItem: updateSelectedApp, style: { maxWidth: "unset" }, key: "topSampleTemplate__" + template?.id, reInitFromChat: true, showHoverOptions: false, hideDelete: true, hideShare: true, dontHighlight: true })));
            })));
};
export default SearchTemplateRecommendations;
